/**
 * Tailwind CSS implementation of Indicator component
 * Uses Seeds indicator CSS classes from indicator.css
 */

import * as React from "react";
import Icon from "@sproutsocial/seeds-react-icon";
import type { TypeIndicatorProps } from "./IndicatorTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const IndicatorTailwind = ({
  tooltip = "",
  className,
  ...rest
}: TypeIndicatorProps) => {
  return (
    <span
      className={cn("Indicator", "seeds-indicator", className)}
      data-tip={tooltip}
      data-qa-indicator=""
      aria-label={tooltip}
      tabIndex={0}
      {...(rest as React.ComponentPropsWithoutRef<"span">)}
    >
      {tooltip && <div>{tooltip}</div>}
      <Icon name="circle-fill-solid" size="mini" aria-hidden />
    </span>
  );
};

IndicatorTailwind.displayName = "IndicatorTailwind";
